/**
 * AJAX settings save handler.
 *
 * Intercepts the form submit, serializes all fields (PMW core + add-on tabs),
 * and POSTs to the REST endpoint. Displays success/error notices inline.
 *
 * @since 1.57.0
 */

jQuery(function ($) {

	const $form = $("#pmw_settings_form")

	if (!$form.length) return

	$form.on("submit", function (e) {
		e.preventDefault()

		const $submitBtn    = $form.find("#submit")
		const originalLabel = $submitBtn.val()

		// Disable button and show loading state
		$submitBtn.prop("disabled", true).val("Saving…")

		// Remove any previous notices
		$(".pmw-save-notice").remove()

		// Serialize the entire form (captures all tabs including hidden checkbox fallbacks)
		const formData = $form.serialize()

		fetch(pmwAdminApi.root + "pmw/v1/options/save", {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"X-WP-Nonce": pmwAdminApi.nonce,
			},
			body: formData,
		})
			.then(response => response.json())
			.then(data => {

				if (data.success && (!data.errors || data.errors.length === 0)) {
					// Reload the page to refresh PHP-rendered dynamic state (active/inactive badges, etc.)
					// The current tab is preserved via the URL params set by pmwSetUrl()
					window.location.reload()
				} else {
					let errorHtml = data.message || "Settings saved with errors."

					if (data.errors && data.errors.length > 0) {
						errorHtml += "<ul style=\"margin: 4px 0 0 16px; list-style: disc;\">"
						data.errors.forEach(function (err) {
							errorHtml += "<li>" + err + "</li>"
						})
						errorHtml += "</ul>"
					}

					pmwShowSaveNotice("error", errorHtml)
				}
			})
			.catch(err => {
				console.error("PMW settings save error:", err)
				pmwShowSaveNotice("error", "An unexpected error occurred while saving settings. Please try again.")
			})
			.finally(() => {
				$submitBtn.prop("disabled", false).val(originalLabel)
			})
	})

	/**
	 * Show a WordPress-style admin notice after save.
	 *
	 * @param {string} type    "success" or "error"
	 * @param {string} message The HTML message to display
	 */
	function pmwShowSaveNotice(type, message) {
		const noticeClass = type === "success" ? "notice-success" : "notice-error"

		const $notice = $(
			"<div class=\"notice " + noticeClass + " is-dismissible pmw-save-notice\" style=\"margin: 10px 0;\">" +
			"<p>" + message + "</p>" +
			"<button type=\"button\" class=\"notice-dismiss\"><span class=\"screen-reader-text\">Dismiss this notice.</span></button>" +
			"</div>"
		)

		// Insert after the tab wrapper
		$(".nav-tab-wrapper").after($notice)

		// Dismiss handler
		$notice.find(".notice-dismiss").on("click", function () {
			$notice.fadeOut(200, function () {
				$(this).remove()
			})
		})

		// Auto-dismiss success notices after 5 seconds
		if (type === "success") {
			setTimeout(function () {
				$notice.fadeOut(400, function () {
					$(this).remove()
				})
			}, 5000)
		}

		// Scroll to notice
		$("html, body").animate({ scrollTop: $notice.offset().top - 50 }, 300)
	}
})
